/** 定数値 */
export const Constant = {

	/** IDトークンの更新間隔(ミリ秒) */
	RefreshInterval: 10 * 60 * 1000,

};